<template>
  <div></div>
</template>

<script>
export default {
  name: 'MapDefaultViewer'
}
</script>

<style scoped></style>
